import React from 'react';
import cn from 'classnames';
import style from './submit.mod.scss';
import Button from '../button/button';

const Submit = ({ text }) => {
  const classes = cn(style.submit);

  return (
    <div className={classes}>
      <Button type="submit" text='Send'/>
    </div>
  );
};

export default Submit;
